export const languageMap = {
    'uk': 'ua',
    'de': 'dt',
};
